import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNav from './BottomNav'
import MobileHeader from './MobileHeader'
import DesktopHeader from './DesktopHeader'
import DesktopFooter from './DesktopFooter'
import InstallBanner from '@/components/pwa/InstallBanner'
import OfflineBanner from '@/components/pwa/OfflineBanner'
import PushPermissionPrompt from '@/components/pwa/PushPermissionPrompt'
import PopupHost from '@/components/popup/PopupHost'
import { initGA, trackPageView } from '@/lib/analytics'

interface LayoutProps {
  /** 헤더 표시 여부 (현재 미사용, 호출부 호환을 위해 유지) */
  showHeader?: boolean
  /** 하단 탭바 표시 여부 */
  showBottomNav?: boolean
  /** 헤더 제목 (현재 미사용, 호출부 호환을 위해 유지) */
  headerTitle?: string
  /** 뒤로가기 버튼 표시 (현재 미사용, 호출부 호환을 위해 유지) */
  showBack?: boolean
}

// 데스크톱/모바일 분기를 조건부 렌더(useMediaQuery) 가 아닌 CSS 토글로 처리한다.
// 조건부 렌더 시 SSR(false) → mount 직후 미디어쿼리 결과(true) 로 트리 전체가
// 통째로 unmount → AdSense·번역기 등이 미리 만진 노드와 React 의 기대가 어긋나
// "Failed to execute 'removeChild'" 가 발생한다 (2026-05-04 라이브 인시던트).
export default function Layout({
  showBottomNav = true,
}: LayoutProps) {
  const location = useLocation()

  useEffect(() => { initGA() }, [])

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])

  return (
    <div className="flex min-h-dvh flex-col">
      <OfflineBanner />
      <PopupHost />
      <div className="contents lg:hidden">
        <MobileHeader />
      </div>
      <div className="hidden lg:contents">
        <DesktopHeader />
      </div>
      <div className="flex-1">
        <Outlet />
      </div>
      <DesktopFooter />
      {showBottomNav && (
        <div className="contents lg:hidden">
          <BottomNav />
        </div>
      )}
      <div className="contents lg:hidden">
        <InstallBanner />
      </div>
      <PushPermissionPrompt />
    </div>
  )
}
